module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hrms13x-detail-tab1"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['STDEMPC1']['15']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "col-md-1 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "employee-image"
  }, [(_vm.data.empimg !== '') ? [_c('img', {
    staticClass: "empimg",
    attrs: {
      "src": _vm.baseURL + _vm.data.empimg
    }
  })] : [_c('img', {
    staticClass: "empimg",
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  })]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-11"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.codcomp_desc))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 clearfix clear-padding"
  }, [_c('div', {
    staticClass: "unit-group-box clearfix"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['110']))]), _vm._v(" "), _c('div', {
    staticClass: "readonly-group clearfix"
  }, [_c('div', {
    staticClass: "unit-group-left clearfix"
  }, [_c('div', {
    staticClass: "bg-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.data.dteempmt_yr))]), _vm._v(" "), _c('div', {
    staticClass: "unit-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['120']))])]), _vm._v(" "), _c('div', {
    staticClass: "unit-group-right clearfix"
  }, [_c('div', {
    staticClass: "bg-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.data.dteempmt_mt))]), _vm._v(" "), _c('div', {
    staticClass: "unit-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['130']))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 clearfix padding-R-5"
  }, [_c('div', {
    staticClass: "unit-group-box clearfix"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "readonly-group clearfix"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.codpos_desc))]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon text-title"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.numlvl))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 clearfix clear-padding"
  }, [_c('div', {
    staticClass: "unit-group-box clearfix"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "readonly-group clearfix"
  }, [_c('div', {
    staticClass: "unit-group-left clearfix"
  }, [_c('div', {
    staticClass: "bg-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.data.dteempdb_yr))]), _vm._v(" "), _c('div', {
    staticClass: "unit-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['150']))])]), _vm._v(" "), _c('div', {
    staticClass: "unit-group-right clearfix"
  }, [_c('div', {
    staticClass: "bg-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.data.dteempdb_mt))]), _vm._v(" "), _c('div', {
    staticClass: "unit-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['160']))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.codjob_desc))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 clearfix clear-padding"
  }, [_c('div', {
    staticClass: "unit-group-box clearfix"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['170']))]), _vm._v(" "), _c('div', {
    staticClass: "readonly-group clearfix"
  }, [_c('div', {
    staticClass: "unit-group-left clearfix"
  }, [_c('div', {
    staticClass: "bg-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.data.dteeflvl_yr))]), _vm._v(" "), _c('div', {
    staticClass: "unit-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['180']))])]), _vm._v(" "), _c('div', {
    staticClass: "unit-group-right clearfix"
  }, [_c('div', {
    staticClass: "bg-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.data.dteeflvl_mt))]), _vm._v(" "), _c('div', {
    staticClass: "unit-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['190']))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['60']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.codempmt_desc))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 clearfix clear-padding"
  }, [_c('div', {
    staticClass: "unit-group-box clearfix"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['200']))]), _vm._v(" "), _c('div', {
    staticClass: "readonly-group clearfix"
  }, [_c('div', {
    staticClass: "unit-group-left clearfix"
  }, [_c('div', {
    staticClass: "bg-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.data.dteefpos_yr))]), _vm._v(" "), _c('div', {
    staticClass: "unit-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['210']))])]), _vm._v(" "), _c('div', {
    staticClass: "unit-group-right clearfix"
  }, [_c('div', {
    staticClass: "bg-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.data.dteefpos_mt))]), _vm._v(" "), _c('div', {
    staticClass: "unit-readonly clearfix"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['220']))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.typemp_desc))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['230']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.codedlv_desc))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.typpayroll_desc))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['240']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.codinst_desc))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.data.unitcal1 === 'D' ? _vm.labels['STDEMPC1']['91'] : _vm.labels['STDEMPC1']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.salary))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['250']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.codmajsb_desc))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.data.dteempmt)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 readonly-box clearfix clear-padding"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['STDEMPC1']['260']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "form-control bg-readonly"
  }, [_vm._v(_vm._s(_vm.data.codminsb_desc))])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c932a26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms13x/detailTab1.vue
// module id = 3551
// module chunks = 1